export const isStr = (val): val is string => typeof val === "string";

export function isDefined(value) {
    return value !== undefined && value !== null;
}

export function isObject(value) {
    return typeof value === "object" && isDefined(value);
}

export function isFunction(value) {
    return value instanceof Function;
}

export function resolveNested(option, key: string) {
    if (!isObject(option)) {
        return option;
    }

    if (option == null) {
        return null;
    }

    const keys: string[] = key.split(".");
    let value = option;

    for (let i = 0, len = keys.length; i < len; ++i) {
        value = value[keys[i]];
        if (value == null) {
            return null;
        }
    }
    return value;
}

/**
 * Modify a string by removing or adding characters
 * @param str The string to modify
 * @param start index at which to start changing the string
 * @param delCount number of characters to remove
 * @param newSubStr the string to be spliced in
 */
export function splice(str: string, start: number, delCount: number, newSubStr: string) {
    return str.slice(0, start) + newSubStr + str.slice(start + Math.abs(delCount));
}

/**
 * Determines whether an element has a slot. If name is specified, the function will look for a corresponding named slot,
 * otherwise it will look for a "default" slot (e.g. a non-empty text node or an element with no slot attribute).
 * @param el The element
 * @param name The name of the slot
 */
export function hasSlot(el: HTMLElement, name?: string) {
    // Look for a named slot
    if (name) {
        return el.querySelector(`[slot="${name}"]`) !== null;
    }

    // Look for a default slot
    return [...el.childNodes].some((node) => {
        if (
            node.nodeType === node.TEXT_NODE &&
            // eslint-disable-next-line
            node.textContent!.trim() !== ""
        ) {
            return true;
        }

        if (node.nodeType === node.ELEMENT_NODE) {
            const el = node as HTMLElement;
            if (!el.hasAttribute("slot")) {
                return true;
            }
        }

        return false;
    });
}
